import React from 'react';
import logo from './logo.svg';
import './App.css';

import Form from './components/Form';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        ぐちゃぐちゃあっぷ
        <a
          className="App-link"
          href="https://kakuyomu.jp/users/mituha"
          target="_blank"
          rel="noopener noreferrer"
        >
          .
        </a>
      </header>
      <Form />
    </div>
  );
}

export default App;
